module.exports = __webpack_public_path__ + "static/media/blue-bang.01ee8bc4.svg";